import type {
  InsertTagTypeWithOptionalGroupIdMutation,
  InsertTagTypeWithOptionalGroupIdMutationVariables,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertTagTypeWithOptionalGroupIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useInsertTagTypeWithOptionalGroupId = createMutationHook({
  name: 'insertTagType',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.tag.insert.mutationOptions({ onSuccess }),
  mapInput: (variables: InsertTagTypeWithOptionalGroupIdMutationVariables) => ({
    Name: variables.Name ?? '',
    Description: variables.Description ?? null,
    TagTypeGroupId: variables.TagTypeGroupId ?? null,
  }),
  invalidate: (trpc) => [trpc.frontend.tag.pathKey()],
  mapResponse: (result: {
    Id: string;
  }): InsertTagTypeWithOptionalGroupIdMutation => ({
    insert_tag_type_one: {
      __typename: 'tag_type',
      TagTypeId: result.Id,
    },
  }),
  graphqlDocument: InsertTagTypeWithOptionalGroupIdDocument,
  graphqlVariables: (
    variables: InsertTagTypeWithOptionalGroupIdMutationVariables
  ) => ({ ...variables }),
  evictFields: ['tag_type'],
});
